module.exports = __webpack_public_path__ + "images/secondOpenionIcon_a24161f.svg";